import { Alert, Box, Typography } from '@mui/material'
import AdminMainContainer from '../../../layouts/admin/AdminMainContainer'

export default function AdminNotFoundPage() {
  return (
    <AdminMainContainer>
      <Box sx={{ p: 2 }}>
        <Typography variant='h2' mb={2}>
          {'Not Found :('}
        </Typography>
        <Alert severity='error' variant='filled' sx={{ p: 2 }}>
          Your page not exist!
        </Alert>
      </Box>
    </AdminMainContainer>
  )
}
